import { Component, OnInit, EventEmitter } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { FeatureService } from '../../common/feature.service';

@Component({
  selector: 'feature-option-form',
  templateUrl: './feature-option-form.component.html',
  styleUrls: ['./feature-option-form.component.css', '../../app.component.css'],
  providers: [FeatureService]
})
export class FeatureOptionFormComponent implements OnInit {

 eventId: any;
 featureId: any;
 featureOptionForm: any;
 featureOptionId: any;
 featureOption: any;
 spinner: boolean = false;

 constructor(private formBuilder: FormBuilder, private featureService: FeatureService){
  this.featureOptionForm = this.formBuilder.group({
   'id': [''],
   'option': ['', Validators.required],
   'isPrice': ['', Validators.required],
   'price': ['']
  });
  this.featureOption = this.featureOptionForm.value;
 }

 ngOnInit() {
 }

 onSave = new EventEmitter();

 saveFeatureOption() {
  if(this.featureOptionForm.valid)
  {
   this.spinner = true;
   var params = this.featureOptionForm.value;
   params.featureId = this.featureId;
   params.featureOptionId = this.featureOptionId;
   this.featureService.saveFeatureOption(params).subscribe(
    response => {
     this.spinner = false;
     if(response.status)
     this.onSave.emit();
    },
    error => {
     this.spinner = false;
    }
   );
  }
 }

}



// WEBPACK FOOTER //
// /var/www/html/nissco_event_web/angular/src/app/admin/feature-option-form/feature-option-form.component.ts